let uploadInterval = undefined;
let uploadPeriod = 5 * 1000;
let clearSentDataPeriod = 5 * 60 * 1000;
let activeCountdownMilliSecond = 60 * 1000;
let isHandlerActive = true;
let activeTimeout = setTimeout(() => {
    isHandlerActive = false;
}, activeCountdownMilliSecond);

let ACTION_CODE = {
    productDisplay: 'PROD_DISP',
    advertisementDisplay: 'ADVRT_DISP',
    videoAdvertisementDisplay: 'VDO_ADVRT_DISP',
    productClick: 'PROD_CLICK',
    advertisementClick: 'ADVRT_CLICK',
    videoAdvertisementClick: 'VDO_ADVRT_CLICK',
    linkClick: 'LINK_CLICK',
    shopCart: 'SHOP_CART'
};

import { instance } from '@/utils/ajax';
import _vuexStore from '../store';

function sendDataToServer(data) {
    try {
        instance.post('/api/actionHistory/uploadActions', data);
    } catch (e) {
        /* eslint-disable no-console */
        console.error('send statistics data to server failed');
    }
}

const store = {
    get pendingData() {
        try {
            const valRaw = window.localStorage.getItem('marketing_pendingData');
            return JSON.parse(valRaw) || [];
        } catch (e) {
            return [];
        }
    },
    set pendingData(val) {
        try {
            window.localStorage.setItem(
                'marketing_pendingData',
                JSON.stringify(val)
            );
        } catch (e) {
            /*eslint-disable no-console*/
            console.error('error set pending data');
        }
    },
    get sentToServerData() {
        try {
            const valRaw = window.localStorage.getItem(
                'marketing_sentToServerData'
            );
            return JSON.parse(valRaw) || [];
        } catch (e) {
            return [];
        }
    },
    set sentToServerData(val) {
        try {
            window.localStorage.setItem(
                'marketing_sentToServerData',
                JSON.stringify(val)
            );
        } catch (e) {
            /*eslint-disable no-console*/
            console.error('error set sent to server data');
        }
    }
};

export const marketingDataProcessor = {
    start() {
        clearInterval(uploadInterval);
        uploadInterval = setInterval(async () => {
            const currentMilliSec = new Date().getTime();
            // Clear data that were sent to server
            store.sentToServerData = store.sentToServerData.filter(
                v => currentMilliSec - v.onlnShopActDate < clearSentDataPeriod
            );

            const pendingData = store.pendingData.map(d => ({
                ...d,
                milliSecondBeforeSubmit: currentMilliSec - d.onlnShopActDate
            }));
            const sentToServerData = store.sentToServerData;

            if (!pendingData || !pendingData.length) {
                return;
            }

            sendDataToServer(pendingData);

            // //Logging for debug
            // {
            //     /* eslint-disable no-console */
            //     console.log('[MarketingDataProcessor] Sent to server');
            //     pendingData.forEach(v => {
            //         console.log(JSON.stringify(v, null, 4));
            //     });
            //     console.log('--------');
            //     /* eslint-enable no-console */
            // }

            store.sentToServerData = sentToServerData.concat(pendingData);
            store.pendingData = [];
        }, uploadPeriod);
    },
    isStarted() {
        return !!uploadInterval;
    },
    destroy() {
        clearInterval(uploadInterval);
        uploadInterval = undefined;
        store.pendingData = [];
    }
};

const addRecord = (
    prodKey,
    shopListKey,
    actionCode,
    additionalInfo,
    trckSlctKey
) => {
    const isEnableMarketingDataProcessor = !_vuexStore.getters
        .isPreviewShoppingListByShopListKey;
    if (!isEnableMarketingDataProcessor) {
        return;
    }

    const currentMilliSec = new Date().getTime();
    store.pendingData = store.pendingData.concat({
        onlnShopActDate: currentMilliSec,
        onlnShopActCode: actionCode,
        prodKey: prodKey,
        shopListKey: shopListKey,
        onlnShopActParmText: additionalInfo,
        trckSlctKey: trckSlctKey
    });
};

export const marketingEventHandler = {
    productDisplay: (prodKey, shopListKey, cooldownMilliSec = 60 * 1000) => {
        const currentMilliSec = new Date().getTime();

        const checkWithinCooldown = d =>
            d.prodKey === prodKey &&
            currentMilliSec - d.onlnShopActDate < cooldownMilliSec;

        const sameProductWithCooldown =
            store.pendingData.some(checkWithinCooldown) ||
            store.sentToServerData.some(checkWithinCooldown);

        if (!sameProductWithCooldown) {
            addRecord(prodKey, shopListKey, ACTION_CODE.productDisplay);
        }
    },
    advertisementDisplay: (
        prodKey,
        shopListKey,
        advertisementType,
        trckSlctKey
    ) => {
        if (isHandlerActive)
            addRecord(
                prodKey,
                shopListKey,
                ACTION_CODE.advertisementDisplay,
                `type = ${advertisementType}`,
                trckSlctKey
            );
    },
    videoAdvertisementDisplay: (shopListKey, vdoAdvrtType, trckSlctKey) =>
        addRecord(
            undefined,
            shopListKey,
            ACTION_CODE.videoAdvertisementDisplay,
            `type = ${vdoAdvrtType}`,
            trckSlctKey
        ),

    productClick: (prodKey, shopListKey) =>
        addRecord(prodKey, shopListKey, ACTION_CODE.productClick),

    advertisementClick: (
        prodKey,
        shopListKey,
        advertisementType,
        trckSlctKey
    ) =>
        addRecord(
            prodKey,
            shopListKey,
            ACTION_CODE.advertisementClick,
            `type = ${advertisementType}`,
            trckSlctKey
        ),

    videoAdvertisementClick: (shopListKey, vdoAdvrtType, trckSlctKey) =>
        addRecord(
            undefined,
            shopListKey,
            ACTION_CODE.videoAdvertisementClick,
            `type = ${vdoAdvrtType}`,
            trckSlctKey
        ),

    externalLinkClick: (prodKey, shopListKey, additionalInfo, trckSlctKey) =>
        addRecord(
            prodKey,
            shopListKey,
            ACTION_CODE.linkClick,
            additionalInfo,
            trckSlctKey
        ),

    addToCartClick: (prodKey, shopListKey) =>
        addRecord(prodKey, shopListKey, ACTION_CODE.shopCart),

    keepAlive: () => {
        clearTimeout(activeTimeout);
        isHandlerActive = true;
        activeTimeout = setTimeout(() => {
            isHandlerActive = false;
        }, activeCountdownMilliSecond);
    }
};
